import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { ModalComponent, ButtonComponent } from "@evc/web-components";
import { TranslatePipe } from "@ngx-translate/core";
import { EVC_MODAL_REF, ModalRef } from "../../../../_shared/services/modal/evc-modal.service";

@Component({
  selector: "app-migration-failure-modal",
  imports: [CommonModule, ModalComponent, TranslatePipe, ButtonComponent],
  templateUrl: "./migration-failure-modal.component.html",
  styleUrl: "./migration-failure-modal.component.scss"
})
export class MigrationFailureModalComponent {
  private modalRef = inject(EVC_MODAL_REF) as ModalRef<void>;

  retry() {
    this.modalRef.close();
  }
}
